// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Pqyb","bigColWidth":"Table_bigColWidth__1eZ9F","biggerColWidth":"Table_biggerColWidth__24UhW","row":"Table_row__1Xz3-","col":"Table_col__1QUKK"};